export default __webpack_public_path__ + "static/media/EH.b94ababe.svg";